import { AnyAction } from 'redux';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import { setDesignTotalPagesCountAction } from 'src/store/design/slice';

const setDesignTotalPagesCountOperation = (pagesCount: number) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => {
  dispatch(setDesignTotalPagesCountAction(pagesCount));
};

export default setDesignTotalPagesCountOperation;
